import { render } from "./DocumentReportProcessed.vue?vue&type=template&id=584d9e3e&scoped=true&ts=true"
import script from "./DocumentReportProcessed.vue?vue&type=script&lang=ts"
export * from "./DocumentReportProcessed.vue?vue&type=script&lang=ts"

import "./DocumentReportProcessed.vue?vue&type=style&index=0&id=584d9e3e&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584d9e3e"]])

export default __exports__